import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f9f9f9;
`;

const LoginForm = styled.form`
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
`;

const LoginInput = styled.input`
  margin-bottom: 10px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
`;

const LoginButton = styled.button`
  padding: 10px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #0056b3;
  }
`;

const GoogleLoginButton = styled(LoginButton)`
  background-color: #db4437; /* Google button color */
  margin-top: 10px;

  &:hover {
    background-color: #c23321;
  }
`;

const ErrorMessage = styled.p`
  color: red;
  margin-top: 10px;
`;

const Login = ({ setAuthenticated, setUserType }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const redirectUrl = new URLSearchParams(location.search).get('redirectUrl') || '/';

  const handleSubmit = (e) => {
    e.preventDefault();

    if (email === 'user@user.com' && password === 'user') {
      setAuthenticated(true);
      setUserType('user');
      navigate(redirectUrl);
    } else if (email === 'host@host.com' && password === 'host') {
      setAuthenticated(true);
      setUserType('host');
      navigate('/host-portal');
    } else {
      setError('Invalid email or password');
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/google/login`);
      // const response = await fetch('http://localhost:8000/auth/google/login');
      const data = await response.json();
      
      if (data.url) {
        window.location.href = data.url; // Redirect to the Google OAuth URL
      } else {
        setError('Failed to initiate Google login.');
      }
    } catch (error) {
      console.error('Error initiating Google login:', error);
      setError('An error occurred during Google login.');
    }
  };

  return (
    <LoginContainer>
      <LoginForm onSubmit={handleSubmit}>
        <h2>Login</h2>
        <LoginInput
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <LoginInput
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <LoginButton type="submit">Login</LoginButton>
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </LoginForm>

      {/* Google Login Button */}
      <GoogleLoginButton type="button" onClick={handleGoogleLogin}>
        Login with Google
      </GoogleLoginButton>
    </LoginContainer>
  );
};

export default Login;
